var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M17 13.482v2.107a1.4 1.4 0 0 1-.957 1.337 1.4 1.4 0 0 1-.578.068 13.95 13.95 0 0 1-6.075-2.156 13.7 13.7 0 0 1-4.223-4.216 13.9 13.9 0 0 1-2.161-6.09 1.4 1.4 0 0 1 .833-1.412A1.4 1.4 0 0 1 4.407 3h2.111a1.41 1.41 0 0 1 1.408 1.208c.09.675.255 1.337.493 1.974a1.4 1.4 0 0 1-.317 1.483l-.894.892a11.25 11.25 0 0 0 4.224 4.215l.894-.892a1.41 1.41 0 0 1 1.485-.316 9 9 0 0 0 1.978.492 1.41 1.41 0 0 1 1.21 1.426"
  })));
};
export default SvgPhone;